jQuery(document).on('ready', function () {
	jQuery('form.yw-search-form').on('submit', function () {
		var form        = jQuery(this);
		var data        = form.serialize();
		var button      = form.find('[type="submit"]');
		var ajaxResults = form.parent().find('.yw-search-results');

		button.attr('disabled', true).addClass('disabled');
		ajaxResults.hide();

		jQuery.ajax({
			url    : yw_ajaxurl,
			type   : 'POST',
			data   : data,
			success: function (output) {
				button.attr('disabled', false).removeClass('disabled');

				if (output.data.html) {
					ajaxResults.html(output.data.html).show();
				}
			},
			error  : function () {
				button.attr('disabled', false).removeClass('disabled');
			}
		});
		return false;
	});

	// if param yq, fire the search
	var yq = yadore_getParameterByName('yq');
	if (yq) {
		jQuery('form.yw-search-form').submit();
	}
});

function yadore_getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}
